import { CommonHttp } from "@/models/interfaces/http/common.http.request"
import { JobAddition, SimpleName } from "@/store/jobs"


export type NotificationsCount = {
    JobCount: number
    MessageCount: number
}

export type JobNotification = {
    Id: number
    JobId: number
    Creator: SimpleName | null
    Worker: SimpleName | null
    CreateTime: string
    ToDoDate: string | null
    Message: string
    Clients: SimpleName[] | null
    Project: SimpleName | null
    Lost: boolean
    Status: number
    NeedChecking: boolean
    Range: number
    Additions: JobAddition[] | null
}

export const NOTIFICATIONS_PAGE_SIZE = 30

export class NotificationsApi {
    static getCount(): Promise<NotificationsCount> {
        const http = new CommonHttp()
        return http
            .get('notifications/job/count')
            .then(data => data.data)
    }

    static getActive(offset = 0, count = NOTIFICATIONS_PAGE_SIZE): Promise<JobNotification[]> {
        const http = new CommonHttp()
        return http
            .get(`notifications/job/active?Count=${count}&Offset=${offset}`)
            .then(data => data.data)
    }

    static getHistory(offset = 0, count = NOTIFICATIONS_PAGE_SIZE): Promise<JobNotification[]> {
        const http = new CommonHttp()
        return http
            .get(`notifications/job/history?Count=${count}&Offset=${offset}`)
            .then(data => data.data)
    }

    static moveToHistory(notificationId: number): Promise<void> {
        const http = new CommonHttp()
        return http
            .put(`notifications/MoveNotificationToHistory`, { List: [notificationId] })
            .then(() => undefined)
    }

    static moveAllToHistory(notificationIds: number[]): Promise<void> {
        const http = new CommonHttp()
        return http
            .put(`notifications/MoveNotificationToHistory`, { List: notificationIds })
            .then(() => undefined)
    }
}
